<div fxFlex="column" class="confirm-dialog">

    <div class="dialog-header">
     {{ title }}
    </div>
  
    <div class="dialog-container" fxLayout="column">
  
      <div class="dialog-body">
        
        <div fxLayout="column">
          <div fxFlex fxLayout="column" fxLayoutAlign="space-around" fxLayoutGap="10px grid">
            <div class="student-container" *ngFor="let student of students" fxLayoutAlign="center center">
              <mat-card fxFlex class="student-card"
                 fxLayout="row"
                fxLayoutAlign="space-around center">
                <div fxFlex="75" class="module-name">
                  {{ student.StudentName }}
                </div>
              </mat-card>
            </div>
          </div>
        </div>
      </div>
  
      <div class="button-container" fxLayout="row" fxLayoutAlign="space-around center">
        <div>
          <button class="cancel-button button" mat-button type="button" (click)="onCancel()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  